/** Removes the query paramter from the browser state and URL. */
export function removeQueryParameter(parameter: string) {
  const url = new URL(globalThis.location.href)
  url.searchParams.delete(parameter)
  history.replaceState(undefined, '', url)
}
